"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertBytes32ToProtocols = exports.populateProofs = void 0;
const ethers_1 = require("ethers");
function populateProofs(leaves, merkleTree, newEpoch) {
    for (const leaf of leaves) {
        leaf.merkleProof = merkleTree.getProof(leaf);
        leaf.epoch = newEpoch;
    }
    return leaves;
}
exports.populateProofs = populateProofs;
function convertBytes32ToProtocols(scores) {
    const protocolMap = {};
    const convertedScores = [];
    for (const score of scores) {
        if (!(score.protocol in protocolMap)) {
            protocolMap[score.protocol] = ethers_1.utils.parseBytes32String(score.protocol);
        }
        convertedScores.push(Object.assign(Object.assign({}, score), { protocol: protocolMap[score.protocol] }));
    }
    return convertedScores;
}
exports.convertBytes32ToProtocols = convertBytes32ToProtocols;
//# sourceMappingURL=score.js.map